import { Modal, Tooltip } from "@material-ui/core";
import React from "react";

interface SettingsInstructionsModalProps {
  title: string;
  preamble?: string;
  instructions: string;
  open: boolean;
  onClose: () => void;
}

export const SettingsInstructionsModal = (
  props: SettingsInstructionsModalProps,
): JSX.Element => {
  const [open, setOpen] = React.useState(props.open);
  const [tooltipTimer, setTooltipTimer] = React.useState<NodeJS.Timeout>();

  const onClose = () => {
    setOpen(false);
    props.onClose();
  };

  const onCopyInstructions = () => {
    navigator.clipboard.writeText(props.instructions);
    if (tooltipTimer) {
      clearTimeout(tooltipTimer);
    }
    setTooltipTimer(
      setTimeout(() => {
        setTooltipTimer(undefined);
      }, 3000),
    );
  };

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  React.useEffect(() => {
    return () => {
      if (tooltipTimer) {
        clearTimeout(tooltipTimer);
        setTooltipTimer(undefined);
      }
    };
  }, []);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="SalesforceInstallModelTitle"
    >
      <div className="modal-content m-8">
        <div className="modal-header">
          <button
            type="button"
            className="close flex items-center w-8 h-8"
            onClick={onClose}
            aria-label="Close"
          >
            <img
              className="align-middle w-full"
              src="/Content/Images/ic_close.svg"
              aria-hidden="true"
            />
          </button>
          <h3 className="modal-title text-display-title">{props.title}</h3>
        </div>
        <div className="modal-body">
          {props.preamble && <p>{props.preamble}</p>}
          <textarea
            className="form-control resize-none"
            readOnly
            id="salesforce_install_instructions"
            style={{ height: "400px" }}
            value={props.instructions}
          ></textarea>
        </div>
        <div className="text-right p-4">
          <Tooltip
            title="Instructions copied to clipboard"
            open={Boolean(tooltipTimer)}
          >
            <button
              id="copy_teams_install"
              type="button"
              onClick={onCopyInstructions}
              className="btn btn-accent"
            >
              Copy Instructions
            </button>
          </Tooltip>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};
